<template>
    <a class="destination" :href="location.link">
        <div class="destination__image" :style="background"></div>
        <div class="destination__name">{{location.name}}</div>
    </a>
</template>
<script>
    export default {
    	props: [
    		"location"
        ],
        computed: {
    		background () {
    			return {
    				"background-image": `url(${this.location.url || "https://placehold.it/300x200"})`
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "~foundation-sites/scss/foundation";
    $margin: .5rem;
    $mobile-header-height: 64px;
    .destination {
        margin: $margin/2 $margin;
        flex: calc(50% - #{1.5 * $margin}) 0;
        position: relative;
        height: 50vw;
        overflow: hidden;
        box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.30);
        transition: all 300ms ease-in-out;
        &:hover {
            cursor: pointer;
            .destination__name {
                background: rgba(0,0,0,.50);
            }
        }
        //size play
        //big image
        &:nth-child(3n) {
            flex: calc(100% - #{2 * $margin}) 0;
        }
        //Margin play
        //first two
        &:nth-child(1),
        &:nth-child(2) {
            margin-top: $margin;
        }
        //last one
        &:nth-last-child(1) {
            margin-bottom: $margin;
        }
        &:nth-child(3n - 2) {
            margin-right: $margin/2 ;
        }
        &:nth-child(3n - 1) {
            margin-left: $margin/2;
        }
        &:nth-child(3n) {
            margin: $margin/2 $margin;
        }
        @include breakpoint(medium) {
            flex: calc(50% - #{1.5 * $margin}) 0;
            height: calc(calc(100vh - #{$mobile-header-height}) / 4 - #{1.5 * $margin});
        }
        &__image {
            display: block;
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            background-color: gray;
            transition: all 200ms ease;
        }
        &__name {
            //element
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            //content
            font-size: 1.7rem;
            @include breakpoint(large) {
                font-size: 2rem;
            }
            font-weight: bold;
            color: white;
            background: rgba(0,0,0,.25);
            //effects
            transition: background 500ms;
        }
    }
</style>


// WEBPACK FOOTER //
// location.vue?651f9750